<template>
  <div class="fix-tab-skeleton" :style="styleObject">
    <div
      class="goods-list-skeleton"
    >
      <div
        class="goods-list-skeleton-content"
        v-for="(item, index) in arr"
        :key="index"
      >
        <Skeleton :styleObject="{
          width: '50px',
          height: '18px',
          marginRight: '20px',
        }" />
      </div>
    </div>
  </div>
</template>

<script>
  import Skeleton from './Skeleton.vue'
  export default {
    name: "TabSkeleton",
    props: {
      styleObject: {
        type: Object,
        default: null
      },
    },
    data() {
      return {
        arr: new Array(5).fill(''),
      };
    },
    components: {
      Skeleton,
    },
  }
</script>
<style lang="less" scoped>
  @375: 320/375;
  .fix-tab-skeleton {
    width: 100%;
    position: absolute;
    z-index: 9999;
    top: 0;
    left: 0;
  }
  .goods-list-skeleton {
    width: 100%;
    box-sizing: border-box;
    padding: 13px * @375;
    display: flex;
    background: #fff;
    &-content {
      // flex-shrink: 0;
      &:last-child {
        margin-right: 0 !important;
      }
    }
  }
</style>
